//src/app/features/questionnaires/create/TaxRequestTarget/useTaxRequestTargetFields.tsx
import { useGetSpecializationsQuery } from 'app/services/accountant';
import { useGetUserBusinessesQuery } from 'app/services/user';
import { useEffect, useState } from 'react';
import { useAuth } from 'utils/AuthProvider';
import { useGetFields } from './fields';

export default function useTaxRequestTargetFields() {
  const { user } = useAuth();
  const { data: businesses, isLoading: isBusinessesLoading } =
    useGetUserBusinessesQuery();
  const { data: specializations, isLoading: isSpecializationsLoading } =
    useGetSpecializationsQuery();
  const [fields, setFields] = useState(useGetFields());

  useEffect(() => {
    let f = [...fields];

    // set options for businesses
    if (businesses && f[0].dependencies?.[0]) {
      const businessOptions =
        businesses?.map((b) => ({
          label: b.name,
          value: b.id.toString(),
        })) || [];

      f[0].dependencies[0].options = businessOptions;
    }
    // set options for specializations

    if (specializations && f[0].dependencies?.[1]) {
      f[0].dependencies[1].options = specializations;
    }
    // set options for dependents if user choose Spouse or Dependent
    if (businesses && f[0].dependencies?.[2].dependencies?.[0]) {
      const spouseorDependentOptions =
        user?.dependents?.map((b) => ({
          label: b.firstname + ' ' + b.lastname,
          value: b.id.toString(),
        })) || [];
      // add Spouse option for dependents if user choose Spouse or Dependent
      user?.spouse &&
        spouseorDependentOptions.unshift({
          label: user.spouse.firstname + ' ' + user.spouse.lastname,
          value: user.spouse.id.toString(),
        });
      f[0].dependencies[2].dependencies[0].options = spouseorDependentOptions;
    }

    setFields(f);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, businesses, specializations]);

  return { fields, isLoading: isBusinessesLoading || isSpecializationsLoading };
}
